<template>
    <div data-app>
        <v-dialog v-model="dialog" persistent max-width="350">
            <v-card>
                <v-card-title class="headline">
                    Emin misiniz?
                </v-card-title>
                <v-card-text
                    >Silmek istediğiniz kayıt kalıcı olarak silinecektir. Bu
                    kaydı silmek istediğinize emin misiniz?</v-card-text
                >
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="text-danger" text @click="dialog = false">
                        Hayır
                    </v-btn>
                    <v-btn class="text-success" text @click="deleteRole">
                        Evet
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <div class="col-md-12">   
            <KTCard v-bind:title="title">
                <template v-slot:body>
                    <form ref="form" id="form" novalidate="novalidate" lazy-validation class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed">
                        <div class="m-portlet__body">
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Kullanıcı Rol Adı:</label>
                                <div class="col-lg-6">
                                    <input type="text" class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="role.name">
                                    <div v-if="errors.name" :errors="errors">
                                        <b-badge v-for="error in errors.name" class="mr-1" :key="error.name" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Arayüz:</label>
                                <div class="col-lg-6">
                                    <input type="text" class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="role.guard_name">
                                    <div v-if="errors.guard_name" :errors="errors">
                                        <b-badge v-for="error in errors.guard_name" class="mr-1" :key="error.guard_name" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Aktif mi?:</label>
                                <div class="col-lg-6">
                                    <b-form-checkbox value="1" switch size="lg" :class="{view: !isEditing}" :disabled="!isEditing" v-model="role.is_active"></b-form-checkbox>
                                    <div v-if="errors.is_active" :errors="errors">
                                        <b-badge v-for="error in errors.is_active" class="mr-1" :key="error.is_active" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Kullanıcılar:</label>
                                <div class="col-lg-6">
                                    <multiselect 
                                        v-model="role.users"
                                        :class="{view: !isEditing}" 
                                        :disabled="!isEditing" 
                                        :options="users" 
                                        :multiple="true" 
                                        :close-on-select="false" 
                                        :clear-on-select="true" 
                                        :preserve-search="false" 
                                        :preselect-first="false" 
                                        :internal-search="false" 
                                        :hide-selected="true"
                                        label="name" 
                                        track-by="name"
                                        @search-change="findByUserName"
                                    >
                                    </multiselect>
                                    <div v-if="errors.users" :errors="errors">
                                        <b-badge v-for="error in errors.users" class="mr-1" :key="error.users" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">İzinler:</label>
                                <div class="col-lg-6">
                                    <multiselect 
                                        v-model="role.permissions"
                                        :class="{view: !isEditing}" 
                                        :disabled="!isEditing" 
                                        :options="permissions" 
                                        :multiple="true" 
                                        :close-on-select="false" 
                                        :clear-on-select="true" 
                                        :preserve-search="false" 
                                        :preselect-first="false" 
                                        :internal-search="false" 
                                        :hide-selected="true"
                                        label="name" 
                                        track-by="id"
                                        @search-change="findByPermissionName"
                                    >
                                    </multiselect>
                                    <div v-if="errors.permissions" :errors="errors">
                                        <b-badge v-for="error in errors.permissions" class="mr-1" :key="error.permissions" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <template v-if="timeStamps">
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-2 col-form-label">Ekleyen:</label>
                                    <div class="col-lg-6">
                                        {{ role.user_created_name }}
                                    </div>
                                </div>
                                
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-2 col-form-label">Ekleme Tarihi:</label>
                                    <div class="col-lg-6">
                                        <span>{{ role.created_at | formatDateTime }}</span>
                                    </div>
                                </div>

                                <div class="form-group m-form__group row">
                                    <label class="col-lg-2 col-form-label">Güncelleyen:</label>
                                    <div class="col-lg-6">
                                        {{ role.user_updated_name }}
                                    </div>
                                </div>

                                <div class="form-group m-form__group row">
                                    <label class="col-lg-2 col-form-label">Güncelleme Tarihi:</label>
                                    <div class="col-lg-6">
                                        <span>{{ role.updated_at | formatDateTime }}</span>
                                    </div>
                                </div>

                        </template>
                          
                        </div>
                        <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
                            <div class="m-form__actions m-form__actions--solid">
                                <div class="row">
                                    <div class="col-lg-2"></div>
                                    <div class="col-lg-6">
                                        <!-- EKLEME BUTONLARI -->
                                        <template v-if="addButtons">
                                            <b-button
                                                v-if="hasPermission('roles.create')"
                                                size="sm"
                                                variant="success"
                                                :disabled="isDisabled"
                                                @click="saveRoleAndGoBack()"
                                            >
                                            <i class="la la-save"></i>
                                            <i class="la la-rotate-left"></i>
                                                Kaydet ve Geri Dön
                                            </b-button>
                                            
                                            <b-button
                                                v-if="hasPermission('roles.create')"
                                                size="sm"
                                                variant="primary"
                                                :disabled="isDisabled"
                                                @click="saveRoleAndAddNew()"
                                            >
                                            <i class="la la-save"></i>
                                                Kaydet ve Yeni Ekle
                                            </b-button>
                                        </template>

                                        <!-- GÜNCELLEME BUTONLARI -->
                                        <template v-if="editButtons">  
                                            <b-button
                                                v-if="hasPermission('roles.update')"
                                                size="sm"
                                                variant="success"
                                                :disabled="isDisabled"
                                                @click="updateRoleAndGoBack()"
                                            >
                                            <i class="la la-save"></i>
                                            <i class="la la-rotate-left"></i>
                                                Güncelle ve Geri Dön
                                            </b-button>

                                            <b-button
                                                v-if="hasPermission('roles.update')"
                                                size="sm"
                                                variant="primary"
                                                :disabled="isDisabled"
                                                @click="updateRole()"
                                            >
                                            <i class="la la-save"></i>
                                                Güncelle
                                            </b-button>

                                            <b-button
                                                v-if="hasPermission('roles.delete')"
                                                size="sm"
                                                variant="danger"
                                                :disabled="isDisabled"
                                                @click="dialog = true"
                                            >
                                            <i class="la la-trash"></i>
                                                Sil
                                            </b-button>

                                            
                                            
                                        </template>

                                        <!-- GÖRÜNTÜLEME BUTONLARI -->
                                        <template v-if="viewButtons">
                                            <b-button
                                                v-if="hasPermission('roles.delete')"
                                                size="sm"
                                                variant="danger"
                                                :disabled="isDisabled"
                                                @click="dialog = true"
                                            >
                                            <i class="la la-trash"></i>
                                                Sil
                                            </b-button>

                                            <b-button
                                                v-if="hasPermission('roles.update')"
                                                size="sm"
                                                variant="success"
                                                :disabled="isDisabled"
                                                @click="changeFormToEditing()"
                                            >
                                            <i class="la la-edit"></i>
                                                Güncellemeyi Aktif Et
                                            </b-button>
 
                                        </template>   
                                        <template>
                                            <b-button 
                                                size="sm" 
                                                @click="$router.go(-1)">
                                                <i class="la la-undo"></i>
                                                İptal
                                            </b-button> 
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </template>
            </KTCard>
        </div>
        <div class="text-center">
            <b-spinner
                variant="primary"
                type="grow"
                label="Spinning"
                v-if="loading"
            ></b-spinner>
        </div>

    </div>
</template>

<script>

import KTCard from "@/view/content/Card.vue";
import { mapGetters} from 'vuex';
import { mapState} from 'vuex';
import { GET_ROLE_DATA } from "@/core/services/store/roles.module";
import { CREATE_ROLE } from "@/core/services/store/roles.module";
import { UPDATE_ROLE } from "@/core/services/store/roles.module";
import { DELETE_ROLE } from "@/core/services/store/roles.module";
import { FIND_BY_USER_NAME } from "@/core/services/store/users.module";
import { FIND_BY_PERMISSION_NAME } from "@/core/services/store/permissions.module";
import Multiselect from 'vue-multiselect'
//import Echo from 'laravel-echo';

export default {
    name: "roles-form",

    data() {
        return {
            dialog: false,
            role:{
                user_created_name: "",
                user_updated_name: ""
            },
            formType: "",
            title: "",
            addButtons: false,
            editButtons: false,
            viewButtons: false,
            timeStamps: false,
            isEditing: true,
            users: [],
            permissions: [],
            
        };
    },
   
    methods: {
        saveRoleAndGoBack() {
            const data = this.role;
            const goBack = true;
            this.$store.dispatch(CREATE_ROLE, {data, goBack})
        },

        saveRoleAndAddNew() {
            const data =  this.role;
            const goBack = false;
            
            
            this.$store.dispatch(CREATE_ROLE, {data, goBack})

            
            
        },

        updateRoleAndGoBack() {
            const data = this.role;
            const goBack = true;
            this.$store.dispatch(UPDATE_ROLE, { data, goBack })
        },

        updateRole() {
            const data = this.role;
            const goBack = false;
            this.$store.dispatch(UPDATE_ROLE, { data, goBack })
        },

        deleteRole() {
            var itemToDelete = this.role.id;
            this.$store.dispatch(DELETE_ROLE, { itemToDelete })
            .then(() => { 
                this.$router.go(-1);
                this.dialog = false;
            })
        },

        changeFormToAdding(){
            this.title = "Kullanıcı Rolü: Yeni Kayıt Formu"
            
            this.addButtons = true;
            this.editButtons = false;
            this.viewButtons = false;
            this.timeStamps = false;
            this.isEditing = true;
        },

        changeFormToEditing(){
            this.title = "Kullanıcı Rolü: Güncelleme Formu"
            this.addButtons = false;
            this.editButtons = true;
            this.viewButtons = false;
            this.timeStamps = true;
            this.isEditing = true;
        },

        changeFormToViewing(){
            this.title = "Kullanıcı Rolü: Detaylar"
            this.addButtons = false;
            this.editButtons = false;
            this.viewButtons = true;
            this.timeStamps = true;
            this.isEditing = false;
        },

        hasPermission(permission) {
            return this.currentUserMenu.permissions.some(function(el) {
                return el.name === permission;
            }); 
        },

        findByUserName (searchText) {
            var x = 1;
            
            if((searchText.length)>2){
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.$store.dispatch(FIND_BY_USER_NAME, {searchText, x})
                    .then((response) => {
                        this.users = response.data;
                    })
                }, 500);
            }

        },

        findByPermissionName (searchText) {
            var x = 1;
            
            if((searchText.length)>2){
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.$store.dispatch(FIND_BY_PERMISSION_NAME, {searchText, x})
                    .then((response) => {
                        this.permissions = response.data;
                    })
                }, 500);
            }

            
        },
    },


    components: {
        KTCard,
        Multiselect
    },

    created() {
        this.isEditing = !this.isEditing;
        this.formType = this.$route.params.formType;
        this.$store.dispatch('getUserMenu');
        this.$store.dispatch('createRoleForm');
        if (this.formType != "add") {
            var id = this.$route.params.id;
            this.$store.dispatch(GET_ROLE_DATA, { id })
            .then(( response ) => {
                this.role = response.data;
                this.role.user_created_name = response.data.user_created_name[0].name;
                this.role.user_updated_name = response.data.user_updated_name[0].name;
            })
        }

    },

    mounted(){
        
        if(this.formType === "add"){
            this.changeFormToAdding();
        }
        if(this.formType === "edit"){
            this.changeFormToEditing();
        }
        if(this.formType === "view"){
            this.changeFormToViewing();
        }
    },

    computed: {
        ...mapGetters(["currentUserMenu"]),

        ...mapState({
            loading: state => state.roles.loading,
            row: state => state.roles.row,
            errors: state => state.roles.errors,
            isDisabled: state => state.roles.isDisabled,
            //user: state => state.users.user_data
        })
    }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.view {
    border-color: transparent;
    background-color: initial;
    color: initial
}
</style>
